export const environment = {
  production: false,
  apiUrl: 'https://dev-api.delivery.fleetoperate.com',
  signinSuccessPath: '/',
  contactUsUrl: 'http://dev.fleetoperate.com/index.php/contacts',
  fleetOperateUrl: 'https://fleetoperate.com/',
  loggingEnabled: true
};
